import axios from "axios";

export default class stopsAPI {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getStops() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/map/stops/`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async postStops(bucket, key) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/map/stops/syncStop/`,
        data: {
          srcBucket: bucket,
          src: key
        }
      });

      return response;
    } catch (error) {
      throw error;
    }
  }
  async postStopsFile(url, fileName) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/files/`,
        data: {
          fileName: fileName,
          source: url
        }
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }
  async getStopsFiles() {
    try {
      const requests = [
        axios({
          method: "get",
          url: `${this.API_LINK}/bin/files/prod_stops`
        })
      ];
      const response = await Promise.all(requests);
      return response.map(resp => resp.data);
    } catch (error) {
      throw error;
    }
  }
}
